import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { getLanguageFromUrl } from 'shared/helpers/parseUrl';
import { Key } from 'i18n/Key';

import en from 'i18n/translations/en.json';
import ro from 'i18n/translations/ro.json';
import it from 'i18n/translations/it.json';
import sv from 'i18n/translations/sv.json';
import tr from 'i18n/translations/tr.json';
import es from 'i18n/translations/es.json';
import hr from 'i18n/translations/hr.json';
import ja from 'i18n/translations/ja.json';
import ru from 'i18n/translations/ru.json';
import fr from 'i18n/translations/fr.json';
import bg from 'i18n/translations/bg.json';
import id from 'i18n/translations/id.json';
import ko from 'i18n/translations/ko.json';
import nl from 'i18n/translations/nl.json';
import pt from 'i18n/translations/pt.json';
import th from 'i18n/translations/th.json';
import vi from 'i18n/translations/vi.json';
import zh from 'i18n/translations/zh.json';
import el from 'i18n/translations/el.json';
import fi from 'i18n/translations/fi.json';
import no from 'i18n/translations/no.json';
import uk from 'i18n/translations/uk.json';
import de from 'i18n/translations/de.json';

export const DEFAULT_NS = 'translation';
export const DEFAULT_LANG = 'en';

const resources = {
  en: {
    [DEFAULT_NS]: en,
  },
  it: {
    [DEFAULT_NS]: it,
  },
  ro: {
    [DEFAULT_NS]: ro,
  },
  sv: {
    [DEFAULT_NS]: sv,
  },
  tr: {
    [DEFAULT_NS]: tr,
  },
  es: {
    [DEFAULT_NS]: es,
  },
  hr: {
    [DEFAULT_NS]: hr,
  },
  ja: {
    [DEFAULT_NS]: ja,
  },
  ru: {
    [DEFAULT_NS]: ru,
  },
  fr: {
    [DEFAULT_NS]: fr,
  },
  bg: {
    [DEFAULT_NS]: bg,
  },
  id: {
    [DEFAULT_NS]: id,
  },
  ko: {
    [DEFAULT_NS]: ko,
  },
  nl: {
    [DEFAULT_NS]: nl,
  },
  pt: {
    [DEFAULT_NS]: pt,
  },
  th: {
    [DEFAULT_NS]: th,
  },
  vi: {
    [DEFAULT_NS]: vi,
  },
  zh: {
    [DEFAULT_NS]: zh,
  },
  el: {
    [DEFAULT_NS]: el,
  },
  fi: {
    [DEFAULT_NS]: fi,
  },
  no: {
    [DEFAULT_NS]: no,
  },
  uk: {
    [DEFAULT_NS]: uk,
  },
  de: {
    [DEFAULT_NS]: de,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: getLanguageFromUrl(),
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
});

export const addDefaultTranslates = (
  trans: { [key in keyof typeof Key]?: string },
) => {
  const defaultTrans = i18n.getResourceBundle(DEFAULT_LANG, DEFAULT_NS);
  Object.entries(trans).forEach(([key, img]) => {
    if (!defaultTrans[img])
      i18n.addResources(DEFAULT_LANG, DEFAULT_NS, { [key]: img });
  });
};
